"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EtherPaymentFallback__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        payable: true,
        stateMutability: "payable",
        type: "fallback",
    },
];
const _bytecode = "0x6080604052348015600f57600080fd5b50603b80601d6000396000f3fe608060405200fea265627a7a72315820021bbf1c5dcdeb18db875aef8191c3ba4c93674328af3e067898974f1b16feb364736f6c63430005110032";
class EtherPaymentFallback__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.EtherPaymentFallback__factory = EtherPaymentFallback__factory;
EtherPaymentFallback__factory.bytecode = _bytecode;
EtherPaymentFallback__factory.abi = _abi;
